import { useState, useEffect } from 'react';
import initSqlJs from 'sql.js';

const useSqlDatabase = (file) => {
  const [db, setDb] = useState(null);

  useEffect(() => {
    const loadDBFile = async () => {
      try {
        const SQL = await initSqlJs({
          locateFile: (file) => `https://sql.js.org/dist/${file}`
        });

        if (file) {
          const reader = new FileReader();
          reader.onload = (event) => {
            const arrayBuffer = event.target.result;
            const uint8Array = new Uint8Array(arrayBuffer);
            const loadedDB = new SQL.Database(uint8Array);
            setDb(loadedDB);
          };
          reader.readAsArrayBuffer(file);
        }
      } catch (error) {
        console.error('Error loading SQLite database:', error);
      }
    };

    loadDBFile();
  }, [file]);

  return db;
};

export default useSqlDatabase;
